import React from 'react'
import moment from 'moment'
import { providerLabel } from './aiCostFormat'

const DATE_FORMAT = 'YYYY-MM-DD'
// Days are UTC days, same as the Deepgram console
export const DASHBOARD_TIMEZONE = 'UTC'
const QUICK_RANGES = [
  { label: '7D', days: 7 },
  { label: '30D', days: 30 },
  { label: '90D', days: 90 },
]

export const defaultFilters = () => ({
  projectId: '',
  startDate: moment.utc().subtract(29, 'days').format(DATE_FORMAT),
  endDate: moment.utc().format(DATE_FORMAT),
  provider: '',
  model: '',
  feature: '',
})

const Select = ({ label, value, onChange, options, allLabel = 'All' }) => (
  <label className="ai-cost-filter">
    <span>{label}</span>
    <select className="form-select form-select-sm" value={value} onChange={(e) => onChange(e.target.value)}>
      <option value="">{allLabel}</option>
      {options.map((o) => (
        <option key={o.value} value={o.value}>
          {o.label}
        </option>
      ))}
    </select>
  </label>
)

/** One row of filters above the dashboard. All filtering is done by the backend. */
const AIFilters = ({ filters, onChange, options = {} }) => {
  const set = (patch) => onChange({ ...filters, ...patch })
  const today = moment.utc().format(DATE_FORMAT)
  const activeQuick = QUICK_RANGES.find(
    (r) => filters.endDate === today && filters.startDate === moment.utc().subtract(r.days - 1, 'days').format(DATE_FORMAT)
  )

  const models = (options.models || []).filter((m) => !filters.provider || m.provider === filters.provider)

  return (
    <div className="ai-cost-filters">
      <Select
        label="Project"
        value={filters.projectId}
        allLabel="All projects"
        onChange={(projectId) => set({ projectId })}
        options={(options.projects || []).map((p) => ({
          value: p._id,
          label: `${p.project_id ? `${p.name} (${p.project_id})` : p.name}${p.hasKeys ? ' •' : ''}`,
        }))}
      />

      <div className="ai-cost-filter ai-cost-filter-dates">
        <span>Date range</span>
        <div className="ai-cost-date-row">
          <div className="btn-group" role="group" aria-label="Quick date range">
            {QUICK_RANGES.map((r) => (
              <button
                key={r.days}
                type="button"
                className={`btn btn-sm ${activeQuick?.days === r.days ? 'btn-secondary' : 'btn-outline-secondary'}`}
                onClick={() => set({ startDate: moment.utc().subtract(r.days - 1, 'days').format(DATE_FORMAT), endDate: today })}>
                {r.label}
              </button>
            ))}
          </div>
          <input
            type="date"
            aria-label="From"
            className="form-control form-control-sm ai-cost-date"
            value={filters.startDate}
            max={filters.endDate}
            onChange={(e) => e.target.value && set({ startDate: e.target.value })}
          />
          <span className="text-muted">–</span>
          <input
            type="date"
            aria-label="To"
            className="form-control form-control-sm ai-cost-date"
            value={filters.endDate}
            min={filters.startDate}
            max={today}
            onChange={(e) => e.target.value && set({ endDate: e.target.value })}
          />
        </div>
      </div>

      <Select
        label="Provider"
        value={filters.provider}
        onChange={(provider) => set({ provider, model: '' })}
        options={(options.providers || []).map((p) => ({ value: p, label: providerLabel(p) }))}
      />
      <Select
        label="Model"
        value={filters.model}
        onChange={(model) => set({ model })}
        options={models.map((m) => ({ value: m.model, label: filters.provider ? m.model : `${m.model} (${providerLabel(m.provider)})` }))}
      />
      <Select
        label="Feature"
        value={filters.feature}
        onChange={(feature) => set({ feature })}
        options={(options.features || []).map((f) => ({ value: f, label: f }))}
      />

      <button type="button" className="btn btn-sm btn-link ai-cost-reset" onClick={() => onChange(defaultFilters())}>
        Reset
      </button>
    </div>
  )
}

export default AIFilters
